import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { Disclaimer, FutureBenefitsDisclaimerModel } from "src/app/models/disclaimer";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-disclaimer',
    templateUrl: './disclaimer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisclaimerComponent implements OnChanges, OnInit {
    @Input() public futureBenefitsDisclaimer: FutureBenefitsDisclaimerModel;
    @Input() public disclaimer: Disclaimer;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public isAgree: boolean;

    ngOnInit(): void {
        if (this.futureBenefitsDisclaimer)
            this.isAgree = true;
        if (this.disclaimer?.disclaimer) {
            this.disclaimer.disclaimer = this.disclaimer.disclaimer.replace(/#221e1f/g, 'var(--fontColor)');
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.isAgree = false;
    }

    public toggleAgreement(): void {
        this.isAgree = !this.isAgree;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitAgreemt(): void {
        if (this.isAgree)
            this.emitComplete.emit();
    }
}